import moment from "moment";

const date = (v: any): boolean => moment(v).isValid();

export default date;
